import 'antd/dist/antd.css';

import { Button, Card, DatePicker, Input, Tab } from '@alifd/next';
import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  NotificationTwoTone,
  PlusOutlined,
} from '@ant-design/icons';
import {
  Col,
  Form,
  Image,
  InputNumber,
  message,
  Modal,
  Radio,
  Row,
  Select,
  Table,
  Upload,
} from 'antd'; // dialog UI
import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';

import EditDocument from '@/components/UI/EditDocument';
import useService from '@/lib/hooks/useService';

import client from '../../../../lib/feathers';
import ChooseType from './chooseType';
import styles from './index.module.scss';
import OpenTimeDialog from './openTimeDialog';
import Setting from './Setting';

const Option = Select.Option;
const PublicAppointmentHomepage = ({ showButton }) => {
  const [form] = Form.useForm();
  const [publicAppointForm] = Form.useForm();
  const [publicInformationCountArr, updatePublicInformationCountArr] =
    useService({
      collectionName: 'publicInformationCount',
    });
  const [publicInformationHourArr, updatePublicInformationHourArr] = useService(
    {
      collectionName: 'publicInformationHour',
    }
  );
  const [publicAppointmentHourArr, updatePublicAppointmentHourArr] = useService(
    {
      collectionName: 'publicAppointmentHour',
    }
  );
  const [publicAppointmentCountArr, updatePublicAppointmentCountArr] =
    useService({
      collectionName: 'publicAppointmentCount',
    });
  const [publicInformationFile, setPublicInformationFile] = useState([]);
  const [publicInformationRule, setPublicInformationRule] = useState([]);
  const [baDeviceArr] = useService({
    collectionName: 'baDevice',
    query: { group: '門禁' },
  });
  const [isUpdate, setIsUpdate] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const [chooseObject, setChooseObject] = useState(null);

  // 營業時間設定
  const [dayAllowTime, setDayAllowTime] = useState([
    [],
    [],
    [],
    [],
    [],
    [],
    [],
  ]);
  const [openTimeStatus, setOpenTimeStatus] = useState([
    'no',
    'no',
    'no',
    'no',
    'no',
    'no',
    'no',
  ]);
  const [openTime, setOpenTime] = useState([[], [], [], [], [], [], []]);
  const [openTimeDialog, setOpenTimeDialog] = useState(false);
  const [openTimeIndex, setOpenTimeIndex] = useState(0);

  const [publicObject, setPublicObject] = useState({});
  const [publicStatus, setPublicStatus] = useState('');
  const [publicDialogStatus, setPublicDialogStatus] = useState('');
  const [showPublicDialog, setShowPublicDialog] = useState(false);
  const week = ['一', '二', '三', '四', '五', '六', '日'];
  const user = useSelector((state) => state.user);
  const [allowedFuncs, setAllowedFuncs] = useState([]);
  const [addPublicDialog, setAddPublicDialog] = useState(false);
  const [updatePublic, setUpdatePublic] = useState({});
  const [chooseTypeDialog, setChooseTypeDialog] = useState(false);
  const [publicAppointmentDialog, setPublicAppointmentDialog] = useState(false);
  const [appointmentAllowDialog, setAppointmentAllowDialog] = useState(false);
  const [appointmentHistoryDialog, setAppointmentHistoryDialog] =
    useState(false);
  const [appointmentAllow, setAppointmentAllow] = useState({});
  const [time, setTime] = useState('');
  const [tabValue, setTabValue] = useState('all');

  useEffect(() => {
    if (user.userGroup.key) {
      const checkedKeys = user.userGroup.key.checkedKeys;
      setAllowedFuncs(checkedKeys);
    }
  }, [user]);

  useEffect(() => {
    updatePublicInformationCountArr();
    updatePublicInformationHourArr();
    updatePublicAppointmentHourArr();
    updatePublicAppointmentCountArr();
  }, [
    isUpdate,
    updatePublicInformationCountArr,
    updatePublicInformationHourArr,
    updatePublicAppointmentHourArr,
    updatePublicAppointmentCountArr,
  ]);
  const layout = {
    labelCol: { span: 18 },
    wrapperCol: { span: 18 },
  };

  const onFinish = async (value, dbName) => {
    try {
      let newValue = { ...value };
      for (const key in value) {
        if (value[key] === undefined) newValue[key] = null;
      }
      newValue = {
        ...newValue,
        dayAllowTime,
        openTimeStatus,
        publicExpireTime:
          value.publicExpireTimeNum + value.publicExpireTimeUnit,
        baId: newValue.baId === null ? [] : newValue.baId,
        publicRentalEquipment:
          newValue.publicRentalEquipment === null
            ? []
            : newValue.publicRentalEquipment,
      };

      if (newValue.files && newValue.files.length > 0)
        delete newValue.files[0].originFileObj;
      if (publicDialogStatus === 'insert') {
        await client.service(dbName).create(newValue);
        setIsUpdate((pre) => !pre);
        Swal.fire('成功!', '此公設已新增', 'success');
        setAddPublicDialog(false);
        form.resetFields();
      } else {
        await client.service(dbName).update(updatePublic._id, newValue);
        setIsUpdate((pre) => !pre);
        Swal.fire('成功!', '更新成功', 'success');
        setAddPublicDialog(false);
        form.resetFields();
      }
    } catch (error) {
      console.error(error);
    }
  };

  // 圖片檔案上傳
  const uploadFiles = (dbName, file, category) => {
    const formData = new FormData();
    formData.append('files', file);
    const res = axios.post(
      `/newUploads?type=${dbName}&category=${category}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          authorization: localStorage.getItem('feathers-jwt'),
        },
      }
    );
    return res;
  };
  // 圖片刪除
  const deleteFile = (file) => {
    client.service('uploads').remove(file.response._id);
    setIsUpdate((pre) => !pre);
  };

  const handlePreview = async (file) => {
    setPreviewImage(file.response.showPath);
    setPreviewOpen(true);
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf('/') + 1)
    );
  };

  const onDelete = async (item, dbName) => {
    const result = await Swal.fire({
      title: '確定刪除公設?',
      text: '刪除後將無法復原!!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#BEBEBE',
      confirmButtonText: '確定',
      cancelButtonText: '取消',
    });
    if (result.isConfirmed) {
      await client.service(dbName).remove(item._id);
      setIsUpdate((pre) => !pre);
      Swal.fire('成功!', '刪除成功', 'success');
    }
  };

  const onPublicFinish = async (value, dbName) => {
    console.log(value);
    let newValue = {
      ...value,
      isDeductionPoint: false,
      status: '預約中',
      publicName: publicObject.publicName,
      targetId: publicObject._id,
      publicAppointmentDate:
        publicStatus === 'hour'
          ? moment(
              `${moment(value.publicAppointmentDate).format('YYYY/MM/DD')} ${
                value.publicAppointmentTime
              }`
            ).valueOf()
          : moment(value.publicAppointmentDate).format('YYYY/MM/DD'),
      files: publicObject.files,
      publicDeductPointsValue:
        publicAppointForm.getFieldValue('PointDeductType') === 'byPersion'
          ? publicObject?.publicDeductPoints * value.publicAppointmentNumber
          : publicObject?.publicDeductPoints,
      finalPoint: publicAppointForm.getFieldValue('finalPoint'),
    };
    if (publicStatus === 'hour') {
      newValue['publicUseTime'] = publicObject.publicUsageTime;
      newValue['appointmentData'] = [
        [value.publicAppointmentTime, value.publicAppointmentNumber],
      ];
    }

    if (publicStatus === 'count')
      newValue['useTime'] =
        publicObject.dayAllowTime[
          moment(value.publicAppointmentDate).isoWeekday() - 1
        ];

    try {
      if (publicDialogStatus === 'insert') {
        await client.service(dbName).create(newValue);
        setIsUpdate((pre) => !pre);
        setPublicAppointmentDialog(false);
        publicAppointForm.resetFields();
        Swal.fire('成功!', '新增公設預約記錄成功', 'success');
      } else {
        await client.service(dbName).update(updatePublic._id, newValue);
        setIsUpdate((pre) => !pre);
        setPublicAppointmentDialog(false);
        publicAppointForm.resetFields();
        Swal.fire('成功!', '修改公設預約記錄成功', 'success');
      }
    } catch (error) {
      console.error(error);
    }
  };

  const disabledPublicDate = (current) => {
    return (
      current < moment().startOf('day') ||
      current >
        moment().add(
          publicObject.publicExpireTimeNum,
          publicObject.publicExpireTimeUnit
        ) ||
      publicObject.dayAllowTime[moment(current).isoWeekday() - 1].length === 0
    );
  };

  const publicColumnsHour = [
    {
      title: '戶號',
      dataIndex: 'householdNumber',
      key: 'householdNumber',
    },
    {
      title: '預約日期',
      dataIndex: 'publicAppointmentDate',
      key: 'publicAppointmentDate',
      render: (value) => moment(value).format('YYYY-MM-DD'),
    },
    {
      title: '預約時段',
      dataIndex: 'publicAppointmentTime',
      key: 'publicAppointmentTime',
      render: (value, record) =>
        value +
        '~' +
        moment(value, 'HH:mm')
          .add(record.publicUseTime, 'hours')
          .format('HH:mm'),
    },
    {
      title: '預約人數',
      dataIndex: 'publicAppointmentNumber',
      key: 'publicAppointmentNumber',
    },
    {
      title: '狀態',
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: '操作',
      dataIndex: '_id',
      render: (value, record) => {
        return (
          <div className={styles.btn}>
            <Button
              type="normal"
              onClick={() => {
                setPublicStatus('hour');
                setPublicDialogStatus('update');
                publicAppointForm.setFieldsValue({
                  ...record,
                  publicAppointmentDate: moment(record.publicAppointmentDate),
                  publicDeductPoints: record.publicDeductPointsValue,
                });
                setUpdatePublic(record);
                setPublicAppointmentDialog(true);
              }}
            >
              編輯
            </Button>
            <Button
              type="primary"
              warning
              onClick={async () => {
                const result = await Swal.fire({
                  title: `確定刪除公設(${record.publicName})的預約?`,
                  text: '刪除後將無法復原!!',
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#BEBEBE',
                  confirmButtonText: '確定',
                  cancelButtonText: '取消',
                });

                if (result.isConfirmed) {
                  await client
                    .service('publicAppointmentHour')
                    .update(record._id, { ...record, status: '已取消' });
                  setIsUpdate((pre) => !pre);
                }
              }}
            >
              刪除
            </Button>
          </div>
        );
      },
    },
  ];
  const publicColumnsCount = [
    {
      title: '戶號',
      dataIndex: 'householdNumber',
      key: 'householdNumber',
    },
    {
      title: '預約日期',
      dataIndex: 'publicAppointmentDate',
      key: 'publicAppointmentDate',
      render: (value) => moment(value).format('YYYY-MM-DD'),
    },

    {
      title: '預約人數',
      dataIndex: 'publicAppointmentNumber',
      key: 'publicAppointmentNumber',
    },
    {
      title: '狀態',
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: '操作',
      dataIndex: '_id',
      render: (value, record) => {
        return (
          <div className={styles.btn}>
            <Button
              type="normal"
              onClick={() => {
                setPublicStatus('count');
                setPublicDialogStatus('update');
                publicAppointForm.setFieldsValue({
                  ...record,
                  publicAppointmentDate: moment(record.publicAppointmentDate),
                  publicDeductPoints: record.publicDeductPointsValue,
                });
                setUpdatePublic(record);
                setPublicAppointmentDialog(true);
              }}
            >
              編輯
            </Button>
            <Button
              type="primary"
              warning
              onClick={async () => {
                const result = await Swal.fire({
                  title: `確定刪除公設(${record.publicName})的預約記錄?`,
                  text: '刪除後將無法復原!!',
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#BEBEBE',
                  confirmButtonText: '確定',
                  cancelButtonText: '取消',
                });

                if (result.isConfirmed) {
                  await client
                    .service('publicAppointmentCount')
                    .update(record._id, { ...record, status: '已取消' });
                  setIsUpdate((pre) => !pre);
                }
              }}
            >
              刪除
            </Button>
          </div>
        );
      },
    },
  ];
  console.log(
    publicAppointForm.getFieldValue('publicAppointmentNumber'),
    '==publicAppointmentNumber'
  );
  return (
    <>
      <div>
        <Button
          type="secondary"
          style={{ marginBottom: '10px' }}
          onClick={() => {
            setAddPublicDialog(true);
            setPublicStatus('hour');
            setPublicDialogStatus('insert');
            setDayAllowTime([[], [], [], [], [], [], []]);
            form.resetFields();
          }}
        >
          建立公設(時段預約)
        </Button>
        <Button
          type="secondary"
          style={{ marginLeft: '10px', marginBottom: '10px' }}
          onClick={() => {
            setAddPublicDialog(true);
            setPublicStatus('count');
            setPublicDialogStatus('insert');
            setDayAllowTime([[], [], [], [], [], [], []]);
            form.resetFields();
          }}
        >
          建立公設(計次預約)
        </Button>
        <EditDocument
          name="公設管理"
          style={{ marginBottom: 10, marginLeft: 10 }}
        />
      </div>
      {/* 設定列 */}

      <div>
        <Setting showButton={showButton} />
      </div>
      <Tab onChange={(value) => setTabValue(value)}>
        <Tab.Item title="全部" key="all" />
        <Tab.Item title="時段預約" key="hour" />
        <Tab.Item title="計次預約" key="count" />
      </Tab>
      {/* 卡片列 */}
      <div>
        {tabValue !== 'count' && (
          <>
            <h1>時段預約</h1>
            {publicInformationHourArr.map((item, index) => {
              return (
                <Card className={styles.card} free key={index}>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      width: '100%',
                      alignItems: 'center',
                    }}
                  >
                    <div>
                      <h1>{item.publicName}</h1>
                    </div>
                    <div>
                      <EyeOutlined
                        style={{ fontSize: 20, marginRight: 10 }}
                        onClick={() => {
                          setPublicObject(item);
                          setPublicStatus('hour');
                          setShowPublicDialog(true);
                        }}
                      />
                      <EditOutlined
                        style={{ fontSize: 20, marginRight: 10 }}
                        onClick={() => {
                          setAddPublicDialog(true);
                          form.setFieldsValue({
                            ...item,
                          });
                          setPublicStatus('hour');
                          setPublicDialogStatus('update');
                          setDayAllowTime(item.dayAllowTime);
                          setOpenTimeStatus(item.openTimeStatus);
                          setUpdatePublic(item);
                        }}
                      />
                      <DeleteOutlined
                        style={{ fontSize: 20, marginRight: 10 }}
                        onClick={() => onDelete(item, 'publicInformationHour')}
                      />
                    </div>
                  </div>
                  <div className={styles.cardContainer}>
                    {/* <img className={styles.img} src={item.files} alt="IMG" /> */}
                    <Image
                      className={styles.img}
                      src={
                        item.files && item.files.length > 0
                          ? item.files[0].response.showPath
                          : '/ezcon/icon/ic_photo.svg'
                      }
                      alt="圖片"
                    />
                    <div style={{ marginLeft: 10 }}>
                      <Button
                        type="secondary"
                        className={styles.cardButtonLeft}
                        onClick={() => {
                          setPublicObject(item);
                          setPublicStatus('hour');
                          setAppointmentHistoryDialog(true);
                        }}
                      >
                        預約紀錄
                      </Button>

                      <Button
                        type="secondary"
                        className={styles.cardButtonRight}
                        onClick={() => {
                          setPublicObject(item);
                          setPublicStatus('hour');
                          setChooseTypeDialog(true);
                          setPublicDialogStatus('insert');
                        }}
                      >
                        我要預約
                      </Button>
                    </div>
                  </div>
                </Card>
              );
            })}
          </>
        )}
        {tabValue !== 'hour' && (
          <>
            <h1>計次預約</h1>
            {publicInformationCountArr.map((item, index) => {
              return (
                <Card className={styles.card} free key={index}>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      width: '100%',
                      alignItems: 'center',
                    }}
                  >
                    <div>
                      <h1>{item.publicName}</h1>
                    </div>
                    <div>
                      <EyeOutlined
                        style={{ fontSize: 20, marginRight: 10 }}
                        onClick={() => {
                          setPublicObject(item);
                          setPublicStatus('count');
                          setShowPublicDialog(true);
                        }}
                      />
                      <EditOutlined
                        style={{ fontSize: 20, marginRight: 10 }}
                        onClick={() => {
                          setAddPublicDialog(true);
                          form.setFieldsValue({ ...item });
                          setPublicStatus('count');
                          setPublicDialogStatus('update');
                          setUpdatePublic(item);
                          setDayAllowTime(item.dayAllowTime);
                          setOpenTimeStatus(item.openTimeStatus);

                          // setAddPublicDialog(true);
                          // form.setFieldsValue({
                          //   ...item,
                          // });
                          // setPublicStatus('hour');
                          // setPublicDialogStatus('update');
                          // setDayAllowTime(item.dayAllowTime);
                          // setUpdatePublic(item);
                        }}
                      />
                      <DeleteOutlined
                        style={{ fontSize: 20, marginRight: 10 }}
                        onClick={() => onDelete(item, 'publicInformationCount')}
                      />
                    </div>
                  </div>
                  <div className={styles.cardContainer}>
                    <Image
                      className={styles.img}
                      src={
                        item.files && item.files.length > 0
                          ? item.files[0].response?.showPath
                          : '/ezcon/icon/ic_photo.svg'
                      }
                      alt="圖片"
                    />
                    <div style={{ marginLeft: 10 }}>
                      <Button
                        type="secondary"
                        className={styles.cardButtonLeft}
                        onClick={() => {
                          setPublicObject(item);
                          setPublicStatus('count');
                          setAppointmentHistoryDialog(true);
                        }}
                      >
                        預約紀錄
                      </Button>

                      <Button
                        type="secondary"
                        className={styles.cardButtonRight}
                        onClick={() => {
                          setPublicObject(item);
                          setPublicStatus('count');
                          setChooseTypeDialog(true);
                          setPublicDialogStatus('insert');
                        }}
                      >
                        我要預約
                      </Button>
                    </div>
                  </div>
                </Card>
              );
            })}
          </>
        )}
      </div>
      {/* 查看Dialog */}
      <Modal
        className={styles.DetailDialog}
        cancelText
        style={{ top: '40px' }}
        title={
          <img
            className={styles.imgModal}
            src={
              publicObject.files && publicObject.files.length > 0
                ? publicObject.files[0].response.showPath
                : '/ezcon/icon/ic_photo.svg'
            }
            alt="IMG"
          />
        }
        mask
        open={showPublicDialog}
        onOk={() => {
          setShowPublicDialog(false);
        }}
        onCancel={() => {
          setShowPublicDialog(false);
        }}
        okText="關閉"
      >
        <h1>{publicObject?.publicName}</h1>
        <pre>{publicObject?.publicContent}</pre>
        <hr />
        <div className={styles.openTimeBox}>
          ,
          <NotificationTwoTone />
          <h3 className={styles.openTime}>開放時間：</h3>
        </div>
        <br />
        {publicObject?.dayAllowTime?.map((dayItem, index) => (
          <div className={styles.openTimeShow} key={index}>
            <div>
              <p>星期{week[index]}: </p>
            </div>
            <div>
              {dayItem.length === 0 && <div>非開放</div>}
              {dayItem.length > 0 &&
              dayItem[0][0] === 0 &&
              dayItem[0][1] === 24 ? (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    textAlign: 'right',
                  }}
                >
                  <div>24小時開放</div>
                </div>
              ) : (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    textAlign: 'right',
                  }}
                >
                  {dayItem.map((timeItem, timeItemKey) => (
                    <div key={timeItemKey}>
                      {timeItem[0]}:00–{timeItem[1]}:00
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}

        <hr />
        <div className={styles.openTimeBox}>
          <NotificationTwoTone />
          <h3 className={styles.openTime}>租借說明：</h3>
        </div>
        <br />
        <p>
          <span className={styles.text}>是否同時段多人預約：</span>{' '}
          {publicObject?.publicMultipleAppointments}
        </p>
        {allowedFuncs.includes('點數管理') && (
          <p>
            <span className={styles.text}>扣點方式：</span>{' '}
            {publicObject?.publicDeductPoints}點
          </p>
        )}
        <p>
          <span className={styles.text}>容納人數：</span>{' '}
          {publicObject?.publicMaxAppointmentsNumber}人
        </p>
        {publicStatus === 'hour' && (
          <p>
            <span className={styles.text}>使用時間限制：</span>{' '}
            {moment()
              .startOf('d')
              .add(publicObject?.publicUsageTime, 'h')
              .format('H小時m分鐘')}
            /每戶
          </p>
        )}

        <p>
          <span className={styles.text}>設施規範：</span>{' '}
          {publicObject?.rule?.name ? (
            <a href={publicObject.rule.path} target="_blank" rel="noreferrer">
              {publicObject.rule.name}
            </a>
          ) : (
            '無檔案'
          )}
        </p>
      </Modal>
      {/* 新增/編輯公設資訊 */}
      <Modal
        width={1000}
        title={`${publicDialogStatus === 'insert' ? '新增' : '編輯'}${
          publicStatus === 'hour' ? '時段' : '計次'
        }公設資料`}
        hasMask
        className={styles.dialog}
        open={addPublicDialog}
        onOk={async () => {
          const result = await Swal.fire({
            title: `確定${
              publicDialogStatus === 'insert' ? '新增' : '編輯'
            }公設?`,
            text: '請確認資料填寫完整!!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#BEBEBE',
            confirmButtonText: '確定',
            cancelButtonText: '取消',
          });
          if (result.isConfirmed) {
            form.submit();
          }
        }}
        onCancel={() => {
          setAddPublicDialog(false);
        }}
        okText="送出"
      >
        <Form
          {...layout}
          className={styles.announcementForm}
          form={form}
          onFinish={(value) =>
            onFinish(
              value,
              publicStatus === 'hour'
                ? 'publicInformationHour'
                : 'publicInformationCount'
            )
          }
          layout="vertical"
          initialValues={{
            publicUsageTime: 1,
            publicUsageTimeUnit: 'h',
            publicExpireTimeNum: 1,
            publicExpireTimeUnit: 'd',
          }}
        >
          <Row>
            <Col span={12}>
              <Form.Item
                label="公設名稱"
                name="publicName"
                rules={[
                  {
                    required: true,
                    message: '請輸入公設名稱',
                  },
                  () => ({
                    async validator(_, value) {
                      console.log(value);
                      const hourRes = await client
                        .service('publicInformationHour')
                        .find({
                          query: { publicName: value },
                        });
                      const countRes = await client
                        .service('publicInformationCount')
                        .find({
                          query: { publicName: value },
                        });
                      if (
                        (hourRes.total === 0 &&
                          countRes.total === 0 &&
                          value !== '' &&
                          publicDialogStatus === 'insert') ||
                        publicDialogStatus === 'update'
                      ) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('此公設名稱已重複'));
                    },
                  }),
                ]}
              >
                <Input />
              </Form.Item>
              {publicStatus === 'hour' && (
                <Form.Item
                  label="使用時間限制"
                  name="publicUsageTime"
                  rules={[
                    {
                      required: true,
                      message: '請輸入使用時間限制',
                    },
                  ]}
                >
                  <InputNumber
                    precision="1"
                    addonAfter={
                      <Form.Item name="publicUsageTimeUnit" noStyle>
                        <Select style={{ width: 80 }} disabled>
                          <Option value="h">小時</Option>
                        </Select>
                      </Form.Item>
                    }
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              )}
              <Form.Item
                label="開放預約期限"
                name="publicExpireTimeNum"
                rules={[
                  {
                    type: 'number',
                    min: 1,
                    required: true,
                    message: '請輸入開放預約期限',
                  },
                ]}
              >
                <InputNumber
                  addonAfter={
                    <Form.Item name="publicExpireTimeUnit" noStyle>
                      <Select style={{ width: 80 }}>
                        <Option value="d">日</Option>
                        <Option value="M">月</Option>
                        <Option value="y">年</Option>
                      </Select>
                    </Form.Item>
                  }
                  style={{ width: '100%' }}
                />
              </Form.Item>
              <Form.Item
                label="是否同時段多戶預約"
                name="publicMultipleAppointments"
                rules={[
                  {
                    required: true,
                    message: '請選擇是否同時段多戶預約',
                  },
                ]}
              >
                <Radio.Group>
                  <Radio value="是"> 是 </Radio>
                  <Radio value="否"> 否 </Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                label="容納人數"
                name="publicMaxAppointmentsNumber"
                rules={[
                  {
                    type: 'number',
                    min: 1,
                    required: true,
                    message: '請輸入容納人數',
                  },
                ]}
              >
                <InputNumber style={{ width: '100%' }} />
              </Form.Item>
              <Form.Item
                label={`扣點方式`}
                name="PointDeductType"
                rules={[
                  {
                    required: true,
                    message: '請選擇扣點方式',
                  },
                ]}
              >
                <Radio.Group>
                  <Radio value="byPersion"> 依照人數扣點 </Radio>
                  <Radio value="byReservation"> 依照預約次數扣點 </Radio>
                </Radio.Group>
                {/* <InputNumber style={{ width: '100%' }} /> */}
              </Form.Item>
              <Form.Item
                label={`扣點點數`}
                name="publicDeductPoints"
                rules={[
                  {
                    type: 'number',
                    min: 0,
                    required: true,
                    message: '請輸入扣點點數',
                  },
                ]}
              >
                <InputNumber style={{ width: '100%' }} />
              </Form.Item>
              <Form.Item
                label="可出租設備"
                name="publicRentalEquipment"
                rules={[
                  {
                    required: false,
                  },
                ]}
              >
                <Select mode="tags" placeholder="請輸入出租設備" />
              </Form.Item>
              <Form.Item
                label="公設簡介"
                name="publicContent"
                rules={[
                  {
                    required: false,
                  },
                ]}
              >
                <Input.TextArea
                  placeholder="請輸入內容"
                  // maxLength={100}
                  rows={6}
                  hasLimitHint
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="files"
                valuePropName="fileList"
                label="上傳圖片"
                getValueFromEvent={(e) => {
                  const { fileList } = e;
                  setPublicInformationFile(fileList);
                  return fileList;
                }}
                rules={[
                  {
                    validator: (_, value) => {
                      if (value) {
                        if (
                          value.map((item) => item.status).includes('uploading')
                        ) {
                          return Promise.reject(new Error('上傳中'));
                        }
                        if (
                          value.map((item) => item.status).includes('error')
                        ) {
                          return Promise.reject(
                            new Error('上傳失敗，請重新上傳或者移除檔案')
                          );
                        }
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Upload
                  onPreview={handlePreview}
                  listType="picture-card"
                  fileList={form.getFieldValue('files')}
                  accept="image/*"
                  customRequest={async (options) => {
                    const { onSuccess, file } = options;
                    if (file.size > 1024 * 1024 * 20) {
                      message.error('上傳檔案不能超過20MB');
                      return;
                    }
                    try {
                      const res = await uploadFiles(
                        publicStatus === 'hour'
                          ? 'publicInformationHour'
                          : 'publicInformationCount',
                        options.file,
                        '圖片'
                      );
                      onSuccess(res.data.length > 0 ? res.data[0] : res.data);
                    } catch (err) {
                      console.log(err);
                    }
                  }}
                  onRemove={async (file) => {
                    try {
                      await deleteFile(file);
                    } catch (err) {
                      console.error({ err });
                    }
                  }}
                >
                  {form.getFieldValue('files')?.length >= 1 ? null : (
                    <div>
                      <PlusOutlined />
                      <div style={{ marginTop: 8 }}>Upload</div>
                    </div>
                  )}
                  {/* <Button>上傳</Button> */}
                </Upload>
              </Form.Item>
              <Form.Item
                name="rule"
                valuePropName="fileList"
                label="上傳設施規範"
                getValueFromEvent={(e) => {
                  const { fileList } = e;
                  setPublicInformationRule(fileList);
                  return fileList;
                }}
                rules={[
                  {
                    validator: (_, value) => {
                      if (value) {
                        if (
                          value.map((item) => item.status).includes('uploading')
                        ) {
                          return Promise.reject(new Error('上傳中'));
                        }
                        if (
                          value.map((item) => item.status).includes('error')
                        ) {
                          return Promise.reject(
                            new Error('上傳失敗，請重新上傳或者移除檔案')
                          );
                        }
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Upload
                  fileList={form.getFieldValue('files')}
                  accept="*"
                  customRequest={async (options) => {
                    const { onSuccess, file } = options;
                    if (file.size > 1024 * 1024 * 20) {
                      message.error('上傳檔案不能超過20MB');
                      return;
                    }
                    try {
                      const res = await uploadFiles(
                        publicStatus === 'hour'
                          ? 'publicInformationHour'
                          : 'publicInformationCount',
                        options.file,
                        '規範'
                      );
                      onSuccess(res.data.length > 0 ? res.data[0] : res.data);
                    } catch (err) {
                      console.log(err);
                    }
                  }}
                  onRemove={async (file) => {
                    try {
                      await deleteFile(file);
                    } catch (err) {
                      console.error({ err });
                    }
                  }}
                >
                  {form.getFieldValue('rule')?.length >= 1 ? null : (
                    <Button>上傳</Button>
                  )}
                </Upload>
              </Form.Item>
              <Form.Item
                label="語音播放裝置"
                name="baId"
                rules={[
                  {
                    required: false,
                  },
                ]}
              >
                <Select mode="multiple" allowClear style={{ width: '100%' }}>
                  {baDeviceArr.map((item) => (
                    <Option value={item._id} key={item._id}>
                      {item.tableText}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item label="營業時間">
                <div className={styles.openTime}>
                  {dayAllowTime.map((dayItem, index) => (
                    <div className={styles.OpenTimeContent} key={index}>
                      <div>
                        星期{week[index]}{' '}
                        <EditOutlined
                          style={{ marginLeft: '10px' }}
                          onClick={() => {
                            setOpenTimeIndex(index);
                            setOpenTimeDialog(true);
                            setOpenTime(dayAllowTime);
                          }}
                        />
                      </div>
                      <div>
                        {dayItem.length === 0 ? (
                          <div>非開放</div>
                        ) : (
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              textAlign: 'right',
                            }}
                          >
                            {dayItem.map((timeItem, index) => {
                              if (timeItem[0] === 0 && timeItem[1] === 24) {
                                return <div key={index}>24小時開放</div>;
                              } else {
                                return (
                                  <div
                                    key={index}
                                  >{`${timeItem[0]}:00 - ${timeItem[1]}:00`}</div>
                                );
                              }
                            })}
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </Form.Item>
              <Form.Item
                label="備註"
                name="publicOpenTimeRemarks"
                rules={[
                  {
                    required: false,
                  },
                ]}
              >
                <Input.TextArea
                  placeholder="請輸入內容"
                  maxLength={100}
                  rows={4}
                  hasLimitHint
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      {/* Upload 顯示圖片 */}
      <Modal
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={() => setPreviewOpen(false)}
      >
        <img
          alt="example"
          style={{
            width: '100%',
          }}
          src={previewImage}
        />
      </Modal>
      {/* 選擇開放時間星期 */}
      <OpenTimeDialog
        openTimeDialog={openTimeDialog}
        setOpenTimeDialog={setOpenTimeDialog}
        openTimeStatus={openTimeStatus}
        setOpenTimeStatus={setOpenTimeStatus}
        openTime={openTime}
        setOpenTime={setOpenTime}
        setDayAllowTime={setDayAllowTime}
        openTimeIndex={openTimeIndex}
        setOpenTimeIndex={setOpenTimeIndex}
      />
      {/* 選擇掃描類別 */}
      <ChooseType
        chooseTypeDialog={chooseTypeDialog}
        setChooseTypeDialog={setChooseTypeDialog}
        chooseObject={chooseObject}
        setChooseObject={setChooseObject}
        setPublicAppointmentDialog={setPublicAppointmentDialog}
        publicAppointForm={publicAppointForm}
        publicObject={publicObject}
      />

      {/* 公設預約單 */}
      <Modal
        width={500}
        title={`${publicDialogStatus === 'insert' ? '新增' : '編輯'}${
          publicObject?.publicName
        }預約單`}
        className={styles.dialog}
        open={publicAppointmentDialog}
        onOk={async () => {
          const result = await Swal.fire({
            title: `確定${
              publicDialogStatus === 'insert' ? '新增' : '編輯'
            }預約(${publicObject?.publicName})公設?`,
            text: '請確認資料填寫完整!!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#BEBEBE',
            confirmButtonText: '確定',
            cancelButtonText: '取消',
          });
          if (result.isConfirmed) {
            publicAppointForm.submit();
          }
        }}
        onCancel={() => {
          publicAppointForm.resetFields();
          setPublicAppointmentDialog(false);
        }}
        okText="送出"
      >
        <Form
          form={publicAppointForm}
          onFinish={(value) =>
            onPublicFinish(
              value,
              publicStatus === 'hour'
                ? 'publicAppointmentHour'
                : 'publicAppointmentCount'
            )
          }
          layout="vertical"
        >
          <Form.Item label="戶號" name="householdNumber">
            {publicAppointForm.getFieldValue('householdNumber')}
          </Form.Item>
          <Form.Item label="用戶名" name="userName">
            <Select>
              {publicAppointForm
                .getFieldValue('userNameArr')
                ?.map((item, index) => (
                  <Select.Option key={index} value={item}>
                    {item}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
          <Form.Item label="人數" name="publicAppointmentNumber">
            <InputNumber />
          </Form.Item>
          {publicStatus === 'hour' && (
            <Form.Item label="使用時間限制" name="publicUseTime">
              {publicAppointForm.getFieldValue('publicUsageTime')}小時
            </Form.Item>
          )}
          <Form.Item
            label="選擇日期"
            name="publicAppointmentDate"
            rules={[
              {
                required: true,
                message: '請選擇日期',
              },
            ]}
          >
            <DatePicker
              disabledDate={disabledPublicDate}
              hasClear={false}
              placeholder="請選擇日期"
              onChange={(value) => setTime(value)}
            />
          </Form.Item>
          {publicStatus === 'hour' && (
            <Form.Item
              label="選擇時段"
              name="publicAppointmentTime"
              rules={[
                {
                  required: true,
                },
                () => ({
                  async validator(_, value) {
                    if (
                      publicAppointForm.getFieldValue(
                        'publicAppointmentTime'
                      ) !== ''
                    ) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('請選擇預約時段'));
                  },
                }),
              ]}
            >
              {publicAppointForm.getFieldValue('publicAppointmentTime') ? (
                <div style={{ display: 'flex' }}>
                  <div style={{ marginRight: 10 }}>
                    {publicAppointForm.getFieldValue('publicAppointmentTime')}
                  </div>
                  <div>
                    <Button
                      disabled={
                        publicAppointForm.getFieldValue('publicAppointmentDate')
                          ? false
                          : true
                      }
                      type="secondary"
                      onClick={async () => {
                        const res = await axios.get(
                          `/ezcon/api/appointmentPeopleNumber?time=${moment(
                            publicAppointForm.getFieldValue(
                              'publicAppointmentDate'
                            )
                          ).valueOf()}&publicName=${publicAppointForm.getFieldValue(
                            'publicName'
                          )}`,
                          {
                            headers: {
                              authorization:
                                localStorage.getItem('feathers-jwt'),
                            },
                          }
                        );
                        console.log(res);
                        setAppointmentAllow(res.data);
                        setAppointmentAllowDialog(true);
                      }}
                    >
                      選擇時段
                    </Button>
                  </div>
                </div>
              ) : (
                <>
                  {/* 請選擇預約時段 */}
                  <Button
                    disabled={
                      publicAppointForm.getFieldValue('publicAppointmentDate')
                        ? false
                        : true
                    }
                    type="secondary"
                    onClick={async () => {
                      const res = await axios.get(
                        `/ezcon/api/appointmentPeopleNumber?time=${moment(
                          publicAppointForm.getFieldValue(
                            'publicAppointmentDate'
                          )
                        ).valueOf()}&publicName=${publicAppointForm.getFieldValue(
                          'publicName'
                        )}`,
                        {
                          headers: {
                            authorization: localStorage.getItem('feathers-jwt'),
                          },
                        }
                      );
                      console.log(res);
                      setAppointmentAllow(res.data);
                      setAppointmentAllowDialog(true);
                    }}
                  >
                    選擇時段
                  </Button>
                </>
              )}
            </Form.Item>
          )}
          {allowedFuncs.includes('點數管理') &&
            publicDialogStatus === 'insert' && (
              <>
                <Form.Item label="原有點數">
                  {publicAppointForm.getFieldValue('finalPoint')}
                </Form.Item>
                <Form.Item
                  label={`使用點數${
                    publicAppointForm.getFieldValue('PointDeductType') ===
                    'byPersion'
                      ? '（依人數扣點）每人' +
                        publicAppointForm.getFieldValue('publicDeductPoints') +
                        '點'
                      : '（依預約次數扣點）每次' +
                        publicAppointForm.getFieldValue('publicDeductPoints') +
                        '點'
                  }`}
                  name="publicDeductPointsValue"
                >
                  -
                  {publicAppointForm.getFieldValue('PointDeductType') ===
                  'byPersion'
                    ? publicAppointForm.getFieldValue('publicDeductPoints') *
                      publicAppointForm.getFieldValue('publicAppointmentNumber')
                    : publicAppointForm.getFieldValue('publicDeductPoints')}
                </Form.Item>
                <Form.Item label="預計剩餘點數">
                  {publicAppointForm.getFieldValue('PointDeductType') ===
                  'byPersion'
                    ? publicAppointForm.getFieldValue('finalPoint') -
                      publicAppointForm.getFieldValue('publicDeductPoints') *
                        publicAppointForm.getFieldValue(
                          'publicAppointmentNumber'
                        )
                    : publicAppointForm.getFieldValue('finalPoint') -
                      publicAppointForm.getFieldValue('publicDeductPoints')}
                </Form.Item>
              </>
            )}
        </Form>
      </Modal>

      {/* 時段表 */}
      <Modal
        className={styles.dialog}
        cancelText
        okText
        title={`請選擇預約時段，每個時段最多可預約${publicObject.publicMaxAppointmentsNumber}人`}
        mask
        footer={null}
        open={appointmentAllowDialog}
        onCancel={() => {
          setAppointmentAllowDialog(false);
        }}
      >
        <div className={styles.timeContainer}>
          {Object.entries(appointmentAllow).map(([key, value]) => {
            return (
              <Button
                disabled={
                  value >=
                    parseInt(publicObject.publicMaxAppointmentsNumber, 10) ||
                  (moment(key, 'HH:mm').valueOf() < moment().valueOf() &&
                    moment().format('YYYY-MM-DD') ===
                      moment(time).format('YYYY-MM-DD'))
                }
                className={styles.timeBox}
                key={key}
                onClick={() => {
                  publicAppointForm.setFieldValue('publicAppointmentTime', key);
                  setTime(value);
                  setAppointmentAllowDialog(false);
                }}
              >
                {`${key} ${' '}
                    ${value}/${publicObject.publicMaxAppointmentsNumber}`}
              </Button>
            );
          })}
        </div>
      </Modal>

      {/* 顯示預約紀錄 */}
      <Modal
        width={1000}
        title={`${publicObject?.publicName}預約紀錄`}
        open={appointmentHistoryDialog}
        footer={null}
        onCancel={() => setAppointmentHistoryDialog(false)}
        onOk={() => setAppointmentHistoryDialog(false)}
      >
        <Table
          dataSource={
            publicStatus === 'hour'
              ? publicAppointmentHourArr.filter(
                  (item) =>
                    item.publicName === publicObject.publicName &&
                    item.status !== '已取消'
                )
              : publicAppointmentCountArr.filter(
                  (item) =>
                    item.publicName === publicObject.publicName &&
                    item.status !== '已取消'
                )
          }
          columns={
            publicStatus === 'hour' ? publicColumnsHour : publicColumnsCount
          }
        />
      </Modal>
    </>
  );
};

export default PublicAppointmentHomepage;
